import { Content } from '../../types';

export const chiangMaiAttractionsContent: Content = {
  title: "אטרקציות נוספות בצ'אנג מאי והסביבה",
  imageUrl:
    '/images/thailand/chiang-mai-attractions/chiang-mai-attractions-wide.jpeg',
  introduction: `צ'אנג מאי, בירת הצפון של תאילנד, מציעה למבקרים מגוון רחב של אטרקציות מרתקות השוכנות בתוך העיר ובסביבתה. העיר משלבת בין תרבות עתיקה, טבע מרהיב וחוויות ייחודיות שמתאימות לכל סוגי המטיילים. להלן אטרקציות בולטות נוספות שמומלץ שלא לפספס:`,
  sections: [
    {
      title: 'אטרקציות טבע ונוף',
      type: 'sub-headers',
      description:
        'אזור צ׳אנג מאי מוקף בנופים מרהיבים, הרים גבוהים ואתרי טבע ייחודיים. הנה כמה מהמקומות המיוחדים שכדאי לבקר בהם:',
      content: [
        {
          subtitle: 'מקדש וואט פרה טאט דוי סוטפ (Wat Phra That Doi Suthep)',
          text: "מקדש וואט פרה טאט דוי סוטפ נחשב לאחד האתרים החשובים ביותר בצ'אנג מאי. הוא ממוקם בראש הר דוי סוטפ ומציע תצפית פנורמית מרהיבה על העיר. המקדש המוזהב נבנה במאה ה -14  ונחשב לאחד המקדשים הקדושים ביותר בצפון תאילנד. הדרך אליו כוללת עלייה של 306 מדרגות מעוטרות בנחשים מיתולוגיים, אך ניתן להגיע גם ברכבל.",
        },
        {
          subtitle: 'מפל Montha Than Waterfall',
          text: "בקרבת מקדש דוי סוטפ נמצא מפל מונטה ת'אן, אחד המפלים היפים בשמורת ההר דוי סוטפ-פוי. המפל מוקף בצמחייה עשירה ומהווה מקום נהדר לפיקניק ולמנוחה בתוך הטבע. מדובר על מפל בן מספר מפלסים, שבו ניתן לטבול ולהתקרר לאחר טיול באזור.",
        },
        {
          subtitle: "הגרנד קניון של צ'אנג מאי (Grand Canyon Chiang Mai)",
          text: "הגרנד קניון של צ'אנג מאי הינו מחצבה ישנה שהפכה לאגם עם צוקים גבוהים ומים בצבע טורקיז. המקום מציע אפשרויות לשחייה, קפיצות למים ופארק מים צף. זהו מקום נהדר להירגע וליהנות מאווירה ייחודית עם נוף יוצא דופן.",
        },
      ],
    },
    {
      title: 'אטרקציות בעלי חיים',
      type: 'sub-headers',
      description:
        'צ׳אנג מאי מציעה מגוון אטרקציות הקשורות לבעלי חיים, המאפשרות למבקרים לפגוש את החי המקומי בסביבה בטוחה ומהנה:',
      content: [
        {
          subtitle: "גן החיות של צ'אנג מאי (Chiang Mai Zoo)",
          text: "גן החיות של צ'אנג מאי, הינו אחד מגני החיות הגדולים בתאילנד ומציע מגוון רחב של בעלי חיים, כולל דובי פנדה, פילים, נמרים וציפורים נדירות. ניתן גם לבקר באקווריום הגדול, שמציג חיי מים מרחבי העולם. גן החיות משתרע על שטח רחב ידיים ומומלץ להשתמש ברכבת הפנימית כדי להגיע לאזורים השונים בו.",
        },
        {
          subtitle: "ספארי הלילה של צ'אנג מאי (Chiang Mai Night Safari)",
          text: "חוויית ספארי הלילה בצ'אנג מאי הינה אחת מהאטרקציות הייחודיות באזור. זהו פארק ספארי שבו המבקרים נוסעים ברכבת פתוחה בין שטחים שבהם מסתובבים חיות בר באופן חופשי. הביקור בספארי כולל מופעי חיות, האכלת טורפים וצפייה בבעלי חיים ליליים בסביבתם הטבעית.",
        },
      ],
    },
    {
      title: 'אטרקציות תרבות והיסטוריה',
      type: 'sub-headers',
      description:
        'צ׳אנג מאי עשירה במורשת תרבותית והיסטורית, עם מבנים עתיקים ואתרים ארכיטקטוניים מרשימים:',
      content: [
        {
          subtitle: "העיר העתיקה של צ'אנג מאי",
          text: "העיר העתיקה של צ'אנג מאי, הינה אזור היסטורי מרתק המוקף חומה ותעלות מים. ברחובות הצרים של העיר ניתן למצוא מקדשים עתיקים, שווקים תוססים, בתי קפה אותנטיים וגלריות אמנות. אחת האטרקציות המרכזיות בעיר העתיקה הינה מקדש וואט צ'די לואנג (Wat Chedi Luang), מקדש מרשים מהמאה ה-14 שמספר את סיפורה של העיר לאורך ההיסטוריה.\n\nהדרך יפה לחוות את העושר התרבותי הזה הינה באמצעות שכירת אופניים במגוון חנויות להשכרת אופניים באזור ולדווש בין הרחובות.",
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, צ'אנג מאי והסביבה מציעות חוויות בלתי נשכחות, בין אם מדובר בתרבות, טבע או אקשן. בביקור בעיר, מומלץ לשלב בין האטרקציות השונות כדי להפיק את המרב מהשהייה בצפון תאילנד.`,
      type: 'text',
      isBold: true,
    },
  ],
};
